let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Vt6S9")).then(() => parcelRequire('1kxh5'));